import { z } from 'zod';
import { reasonSchema } from '../common/primitives.js';
/**
 * Reminder and escalation intervals for tasks and blockers (spec §17: "exact reminder intervals are
 * workspace settings"). These are notification policy only: they never change task state, and
 * consequences of missed work remain a human governance decision (spec §7.13).
 */
export const executionPolicySchema = z.object({
    /** "Due soon" reminder to the owner this many hours before the deadline (0 = off). */
    dueSoonHours: z.number().int().min(0).max(336),
    /** Repeat the overdue reminder every N hours while the task stays open. */
    overdueReminderEveryHours: z.number().int().min(1).max(720),
    /** Escalate an overdue task after this many hours (0 = never escalate). */
    overdueEscalationAfterHours: z.number().int().min(0).max(2160),
    /** Escalations also reach the workspace owner (the task creator is always informed). */
    escalateToWorkspaceOwner: z.boolean(),
    /** Default response window for a blocker without its own SLA. */
    blockerSlaHours: z.number().int().min(1).max(720),
    /** Each further SLA window without a response raises the level, up to this cap. */
    blockerMaxEscalationLevel: z.number().int().min(1).max(10),
});
/** Documented defaults used until the workspace saves its own values (see ADR-0005). */
export const DEFAULT_EXECUTION_POLICY = {
    dueSoonHours: 24,
    overdueReminderEveryHours: 24,
    overdueEscalationAfterHours: 72,
    escalateToWorkspaceOwner: true,
    blockerSlaHours: 48,
    blockerMaxEscalationLevel: 3,
};
export const executionSettingsSchema = executionPolicySchema.extend({
    /** True while the defaults are in effect (nothing saved yet). */
    isDefault: z.boolean(),
    /** 0 when never saved. */
    version: z.number().int().min(0),
});
export const updateExecutionSettingsRequestSchema = executionPolicySchema.extend({
    version: z.number().int().min(0),
    reason: reasonSchema,
});
//# sourceMappingURL=execution-settings.js.map